<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :color="color" small>
        mdi-flag
      </v-icon>
    </template>
    <span>Sender comprometido</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'red accent-4',
    },
  },
};
</script>
